import React from 'react';
import PrintTemplate from "../../../../../components/reports/print-reports/print-template.jsx";

const CeleparDriverContent = ({data, printRef, headerSelected, filters}) => {
    const decamelize = (str = '') => {
        const separator = ' ';

        str = str
            .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
            .toLowerCase();

        return str[0].toUpperCase() + str.slice(1);
    }

    const translateKey = (key) => {
        const model = {
            categVigente: "Categoria",
            cpfNum: "CPF",
            dataValCNH: "Validade",
            nome: "Nome",
            numRegCNH: "CNH",
            numeroCedula: "Número de cédula",
            observacao: "Observação",
            situacaoCNH: "Situação",
            tipoCondutor: "Tipo",
            uf: "UF"
        };

        if (key in model) {
            return model[key];
        } else {
            return decamelize(key);
        }
    }

    const buildTBodyFromObject = (obj = {}, index) => {
        let list = [];
        Object.entries(obj).map(([key, value]) => {
            list.push(<li key={"custom-li-" + key} className="custom-li">{translateKey(key) + ': ' + value}</li>);
        });

        return (
            <ul key={index ? "list-disc-" + index : ""} className="mb-4 !list-disc">
                { list }
            </ul>
        );
    }

    const buildTable = (obg, index = 0) => {
        return (
            <table key={"table-" + index} className={"border border-gray-200"}>
                <thead>
                <tr className="bg-[#f5f5f6] text-left">
                    <th className={"p-[6.4px]"} style={{width: "30%"}}>Placa</th>
                    <th className={"p-[6.4px]"} style={{width: "70%"}}>{obg?.placa ?? ''}</th>
                </tr>
                </thead>
                <tbody className="bg-white [&>tr:nth-child(odd)]:bg-gray-100">
                {
                    Object.entries(obg).map(([key, value]) => {
                        let valueData = "";

                        if (key === 'placa') {
                            return;
                        }

                        if (typeof value === 'string' || value instanceof String) {
                            valueData = value;
                        } else if (value instanceof Object && value.constructor === Object) {
                            valueData = buildTBodyFromObject(value);
                        } else if (Array.isArray(value)) {
                            valueData = value.map((obj, i) => buildTBodyFromObject(obj, i))

                            if (value.length === 0) {
                                valueData = "";
                            }
                        } else {
                            valueData = value;
                        }

                        return (
                            <tr className="table-break-word" key={key}>
                                <td className={"p-[6.4px]"}>{ translateKey(key) }</td>
                                <td className={"p-[6.4px]"}>{ valueData }</td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        )
    }

    return (
        <PrintTemplate title={"Celepar - Pesquisa de condutor"} ref={printRef} entity={headerSelected} printHeaderClassname={"hidden print:block"} printFooterClassname={"hidden print:block"}>
            <article className={"space-y-4"}>
                <section className={"hidden print:flex mb-2 gap-4"}>
                    <p>Tipo: <strong>{filters.type?.label}</strong></p>
                    <p>Valor: <strong>{filters.value}</strong></p>
                </section>

                {
                    data && Array.isArray(data) && data.map((item, index) => buildTable(item, index))
                }

                {
                    data && !Array.isArray(data) && buildTable(data)
                }
            </article>
        </PrintTemplate>
    );
};

export default CeleparDriverContent;